import { render, staticRenderFns } from "./ChangeStatusNota.vue?vue&type=template&id=0b527edc&scoped=true"
import script from "./ChangeStatusNota.vue?vue&type=script&lang=js"
export * from "./ChangeStatusNota.vue?vue&type=script&lang=js"
import style0 from "./ChangeStatusNota.vue?vue&type=style&index=0&id=0b527edc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b527edc",
  null
  
)

export default component.exports